module.exports = __webpack_public_path__ + "img/34_33.82ea65ff.png";